export enum Method {
  SIRA = "SIRA",
  XRF = "XRF",
  ICPMS = "ICPMS",
  SIRAXRF = "SIRA & XRF",
}

// S3 bucket configuration - using your actual bucket and file structure
export const S3_CONFIG = {
  bucketName: 'wfid-web-app-public',
  region: 'eu-north-1',
  baseUrl: 'https://wfid-web-app-public.s3.eu-north-1.amazonaws.com',
};

export const getFileUrl = (method: Method): string => {
  const baseUrl = S3_CONFIG.baseUrl;
  switch (method) {
    case Method.SIRA:
      return `${baseUrl}/20240711_QuerySample_SIRA.xlsx`;
    case Method.XRF:
      return `${baseUrl}/20240711_QuerySample_XRF.xlsx`;
    case Method.ICPMS:
      return `${baseUrl}/20240711_QuerySample_ICPMS.xlsx`;
    case Method.SIRAXRF:
      return `${baseUrl}/20250717_QuerySample_SIRA_XRF.xlsx`;
    default:
      return "";
  }
};

// Function to get the filename for download attribute
export const getFileName = (method: Method): string => {
  switch (method) {
    case Method.SIRA:
      return "20240711_QuerySample_SIRA.xlsx";
    case Method.XRF:
      return "20240711_QuerySample_XRF.xlsx";
    case Method.ICPMS:
      return "20240711_QuerySample_ICPMS.xlsx";
    case Method.SIRAXRF:
      return "20250717_QuerySample_SIRA_XRF.xlsx";
    default:
      return "";
  }
};
